import { imageAsset, modules } from "queries"

export const allNews = `
query( $relatedTo:[QueryArgument], $section:[String], $type:[String], $location: [QueryArgument]) {
  entries(section: $section, type: $type, relatedTo: $relatedTo, locationTag: $location, orderBy: "date") {
    ...on action_Entry {
      id
      typeHandle
      title
      uri
      heading
      date
      image {
        ${imageAsset}
      }
    }
    ...on news_Entry {
      id
      typeHandle
      title
      uri
      newsTag {
        id
        title
        slug
      }
      locationTag {
        id
        title
        slug
      }
      heading
      date
      image {
        ${imageAsset}
      }
    }
    ...on press_Entry {
      id
      typeHandle
      title
      uri
      source: copy
      date
      linkUrl
      image {
        ${imageAsset}
      }
    }
  }
}`

export const featuredAction = `query {
  entries(section: "news", type: "action", limit: 1) {
    id
    title
    uri
    ...on action_Entry {
      typeHandle
      heading
      date
      image {
        ${imageAsset}
      }
    }
  }
}`

export const press = `
query($limit:Int, $offset:Int, $relatedTo:[QueryArgument]) {
  entries(section: "press", limit: $limit, offset: $offset, relatedTo: $relatedTo) {
    id
    title
    uri
    typeHandle
    ...on press_Entry {
      source: copy
      date
      linkUrl
      relatedTag {
        id
        slug
      }
    }
  }
}`

export const pressPage = `query {
  entries(section: "newsIndex") {
    id
    title
    uri
    ...on pressIndex_Entry {
      heading
      slug
      modules {
        ${modules}
      }
      featuredContent {
        id
        title
        slug
        uri
        typeHandle
        ...on news_Entry {
          newsTag {
            id
            title
            slug
          }
          locationTag {
            id
            title
            slug
          }
          heading
          image {
            ${imageAsset}
          }
          date
        }
        ...on story_Entry {
          storyType
          heading
          image {
            ${imageAsset}
          }
          copy
          date
        }
        ...on action_Entry {
          heading
          date
          image {
            ${imageAsset}
          }
        }
      }
    }
  }
}`
